export default __webpack_public_path__ + "static/media/36I-114282_-20925_0.f41b11f9.jpg";